export function dateCdd(value, type, locale, separator) {
    if (!value) return;

    var evalSeparator = [separator ? separator[0] : "", separator ? separator[1] : ""];

    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
    const options = {
        long: {
            "weekday": "long",
            "year": "numeric",
            "month": "long",
            "day": "numeric"
        },
        normal: {
            "year": "numeric",
            "month": "long",
            "day": "numeric"
        },
        short: {
            "year": "numeric",
            "month": "numeric",
            "day": "numeric"
        },
        day: {
            "day": "numeric"
        },
        month: {
            "month": "long",
        },
        year: {
            "year": "numeric",
        },
    }

    return new Date(value).toLocaleString(locale || "en-GB", options[type]).replace(new RegExp(evalSeparator[0], "g"), evalSeparator[1] || evalSeparator[0]);
};


// WEBPACK FOOTER //
// ./src/data/helpers/date-cdd.js